// extracted by mini-css-extract-plugin
export default {"layout":"List_layout__SS6Oe","heading":"List_heading__IYyY-"};